/** Aligns with backend CODING_AT_RISK_INACTIVE_DAYS / batch-insights threshold. */
export const DEFAULT_AT_RISK_INACTIVE_DAYS = 5;

/**
 * At-risk if never submitted (no lastSubmissionAt) or inactive longer than threshold.
 * Uses denormalized `lastSubmissionAt` from StudentProfile when present.
 */
export function isAtRiskStudent(student, thresholdDays = DEFAULT_AT_RISK_INACTIVE_DAYS) {
  if (!student) return false;
  const raw = student.lastSubmissionAt;
  if (raw == null || raw === "") return true;
  const lastMs = new Date(raw).getTime();
  if (Number.isNaN(lastMs)) return true;
  const daysInactive = Math.floor((Date.now() - lastMs) / 86400000);
  return daysInactive > thresholdDays;
}

/** MUI `sx` fragment for DataGrid rows with class `row-at-risk`. */
export const atRiskStudentRowSx = {
  '& .row-at-risk': {
    bgcolor: (theme) =>
      theme.palette.mode === 'dark'
        ? 'rgba(224, 49, 49, 0.14)'
        : 'rgba(211, 47, 47, 0.07)',
    boxShadow: (theme) =>
      `inset 3px 0 0 0 ${theme.palette.error.main}`,
  },
  '& .row-at-risk:hover': {
    bgcolor: (theme) =>
      theme.palette.mode === 'dark'
        ? 'rgba(224, 49, 49, 0.22)'
        : 'rgba(211, 47, 47, 0.11)',
  },
};
